import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import Moment from 'moment';
import { Link } from 'react-router';

import Badge from '../../components/common/badge/Badge';
import Button from '../../components/common/button/Button';
import Card from '../../components/common/card/Card';
import GoogleMap from '../../components/common/map/GoogleMap';
import Rating from '../../components/derived/rating/Rating';
import Spacer from '../../components/common/spacer/Spacer';
import Popover from '../../components/common/popover/Popover';

import TimeUtils from '../../../utils/time';

require('./style.scss');

const DAY_OF_WEEK = _.toLower(Moment().format('dddd'));
const SVG_FILE_PATH = '../../../static/images/';

export default class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      address: '',
      contactNumbers: [],
      expanded: false,
      location: {},
      paymentModes: [],
      shortAddress: '',
      storeName: '',
      timings: [],
      rating: '',
      phoneNumber: 9999999999,
    };
  }

  componentWillMount() {
    this.fetchStoreData(this.props.profile);
  }

  componentWillReceiveProps(nextProps) {
    if ('profile' in nextProps) {
      this.fetchStoreData(nextProps.profile);
    }
  }

  fetchStoreData(profile) {
    if (_.isEmpty(profile)) {
      return;
    }

    const dayOfWeek = _.toLower(Moment().format('dddd'));

    this.setState({
      address: profile.address.area,
      contactNumbers: profile.contact_numbers,
      location: profile.address.location || {},
      paymentModes: profile.supported_payment_modes || [],
      phoneNumber: profile.phone_number,
      rating: profile.rating,
      shortAddress: profile.address.short_address,
      storeName: profile.store_name,
      timings: profile.timings,
      timingsToday: TimeUtils.timingsOnDay(profile.timings, dayOfWeek) || profile.general_timing,
      loader: false,
    });
  }

  render() {
    const { partnerSlug } = this.props;

    const {
      address,
      contactNumbers,
      location,
      storeName,
      rating,
      phoneNumber,
      timings,
      timingsToday,
    } = this.state;

    const contactNumberCount = _.size(contactNumbers);

    return (
      <div className="site-root-header">
        <div className="container-fluid">
          <div className="row" id="header-row">
            <div className="col-lg-17 col-md-17 col-sm-16 col-xs-15">
              <div id="header-heading">
                <h1>{storeName}</h1>
                <Spacer size={1.5} />

                <Link to={`/${partnerSlug}/reviews`}>
                  <Rating
                    rating={_.toNumber(rating)}
                    backgroundColor="#F0C419"
                    color="white"
                  />
                </Link>

                <Spacer size={1.5} />

                <h4>
                  {address}
                </h4>
                <Spacer size={1.5} />

                { timingsToday !== undefined ?
                  <div className="store-timing">
                    <h5 className="store-today-status">{timings.isClosed ? 'Closed' : 'Open Now'}</h5>
                    <div className="time-list">
                      <img alt="time" src={`${SVG_FILE_PATH}timer.svg`} />
                      {_.size(timings) > 0 ?
                        <Popover anchor={<Button.Link label="Timings" color="#ffffff" />}>
                          {_.map(this.state.timings, timing =>
                            <div
                              key={timing.weekday}
                              style={{ color: DAY_OF_WEEK === timing.weekday ? '#000000' : null }}
                            >
                              {TimeUtils.shortWeekday(timing.weekday)}&nbsp;
                              {timing.is_closed ? 'Closed' :
                               TimeUtils.showTimeRange(timing.opening_time || '10:00:00', timing.closing_time || '20:00:00')}
                            </div>)}
                        </Popover> : null}
                    </div>
                    <h5 style={{ margin: 0 }}>
                      {
                        TimeUtils.showTimeRange(timingsToday.opening_time || '10:00:00', timingsToday.closing_time || '20:00:00')
                      }
                    </h5>
                  </div>
                 : ''}
              </div>
              <Spacer size={1.5} />

              <Badge.Group>
                <Badge
                  className="store-number"
                  leftIcon={<img alt="Phone No." src={`${SVG_FILE_PATH}phone-outgoing.svg`} />}
                  label={String(phoneNumber)}
                  backgroundColor=""
                  color="#ffffff"
                />

                {contactNumberCount ?
                  _.map(contactNumbers, contactNumber =>
                    <Badge
                      className="store-number"
                      leftIcon={<img alt="Phone No." src={`${SVG_FILE_PATH}phone-outgoing.svg`} />}
                      label={String(contactNumber)}
                      backgroundColor=""
                      color="#ffffff"
                    />) : ''}
              </Badge.Group>
            </div>
            <div className="col-lg-7 col-md-7 col-sm-8 col-xs-9">
              <div id="powered-by">
                   Powered by&nbsp;
                  <a href="http://mpaani.com" rel="noopener noreferrer" target="_blank">
                    <img alt="m.Paani" src={`${SVG_FILE_PATH}mpaani-logo-white.svg`} />
                  </a>
              </div>
              <div className="store-location">
                <Card>
                  <Card.Content>
                    <Card.Body>
                      {Object.keys(location).length ?
                        <GoogleMap
                          latitude={location.latitude}
                          longitude={location.longitude}
                        /> : '' }
                    </Card.Body>
                  </Card.Content>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Header.propTypes = {
  partnerSlug: PropTypes.string,
  profile: PropTypes.shape({}).isRequired,
};



// WEBPACK FOOTER //
// ./app/layouts/header/Header.jsx